import { useConfig } from "@jti/app-context/useConfig";
import { GoogleAPIProvider } from "@jti/fe-clients";
import { useSelector } from "@jti/store/reduxHooks";
import { selectPostCodeConfig } from "@jti/store/selectors/selectPostCodeConfig";
import { AddressFormProvider } from "@jti/ui/components/AddressFormProvider";

export const AddressForm = () => {
  const { locationServiceAutocompleteProvider, addressFormVariant, GOOGLE_PLACES_KEY } = useConfig();

  const postCodeConfig = useSelector(selectPostCodeConfig);

  return (
    <GoogleAPIProvider apiKey={GOOGLE_PLACES_KEY} options={{ libraries: ["places"] }}>
      <AddressFormProvider
        fieldName={(name: string) => `deliveryAddress.${name}`}
        locationServiceAutocompleteProvider={locationServiceAutocompleteProvider}
        formType={addressFormVariant}
        postCodeConfig={postCodeConfig}
      />
    </GoogleAPIProvider>
  );
};
